import React from "react";
import styled from 'styled-components'
import { CurrencyState } from "../Context";
import { Link } from "react-router-dom";
import { LinearProgress } from "@mui/material";

function CashTransactions() {

    document.title = "Cash Transactions | Lehumo";

    const { symbol, flag, amountBasedOnDollar, cashWallet } = CurrencyState();

    //Amount Deposited or Withdrawn and Fees amount
    const Amount = 10;
    const Fee = 1;

    // Calculate Cash Balance, Transaction Amount and Transaction Fee
    const CashBalanceInLocalCurrency = amountBasedOnDollar * cashWallet;
    const TransactionsAmount = amountBasedOnDollar * Amount;
    const TransactionsFee = amountBasedOnDollar * Fee;


    return (
        <Container>
            <Hero>

                <img src={flag} alt="" />
                <h1>{symbol} {CashBalanceInLocalCurrency.toFixed(2)}</h1>
                <Link to="/AddFunds"><button><i className="fa-solid fa-plus"></i> Add Funds</button></Link> <button><i className="fa-solid fa-bank"></i> Withdraw</button>

            </Hero>

            <TransactionsBox>

                <BackButton>
                    <Link to="/Portfolio"><button><i className="fa-solid fa-arrow-left"></i> Back</button></Link>
                </BackButton>

                <table>
                    <tbody>
                        <tr className='table-header'>
                            <td><b>Amount</b></td>
                            <td><b>Type</b></td>
                            <td><b>Fees</b></td>
                            <td><b>Date</b></td>
                            <td><b>Status </b></td>
                        </tr>

                        <tr>
                            <td>{symbol} {TransactionsAmount.toFixed(2)}</td>
                            <td>Deposit</td>
                            <td className="fees">{symbol} {TransactionsFee.toFixed(2)}</td>
                            <td>10/09/2023</td>
                            <td>Success</td>
                        </tr>

                    </tbody>
                </table>

            </TransactionsBox>
        </Container>
    )
}

export default CashTransactions

const Container = styled.div`
    margin-bottom: 20px;
`

const Hero = styled.div`

    height: 65vh;
    width: 100%;
    padding-top: 100px;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #333;
    background: #f5f8ff;


    h1 {
        padding: 10px 0;
        text-transform: uppercase;
        font-size: 48px;
        font-weight: 500;
        color: var(--primary);
    }

    p {
        margin: 0 0 10px 0;
    }

    button {
        width: 130px;
        height: 50px;
        margin: 10px 0;
        outline: none;
        border: none;
        font-weight: 700;
        text-transform: uppercase;
        box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.1), inset 2px 2px 5px rgba(0, 0, 0, 0.1);
        color: #333;
        border-radius: 10px;


        :hover {
            background-color: #118c4f;
            transition: 0.2s ease-in;
            color: #fff;
            box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.3), inset 2px 2px 5px rgba(0, 0, 0, 0.3);
            transition: 0.3s ease-in;
        }
    }

    img {
        width: 200px;
        height: 130px;
        border-radius: 10px;

    }

    @media (max-width: 768px) {
        height: 50vh;

        h1 {
            font-size: 32px;
        }

        img {
            width: 100px;
            height: 75px;
        }
    }


`

const TransactionsBox = styled.div`

    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;

    h1 {
        padding-top: 50px;
        font-weight: 400;
        font-size: 42px;
        text-transform: uppercase;
    }

    h3 {
        margin: 20px 0;
        font-weight: 600;
        font-size: 24px;
        text-transform: uppercase;
    }

    table {
        width: 90%;
        background-color: #fff;
        margin: 0 auto;
        margin-bottom: 50px;
        border-radius: 10px;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

        tr {
            width: 25%;
            text-align: center;
            
            :hover {
                background-color: #f5f8ff;
                transition: 0.3s ease-in;
                box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            }
        }

        .table-header {
            :hover {
                background-color: #fff;
                box-shadow: none;
            }
        }

        .fees {
            color: red;
        }

        td {
            font-weight: bold;
            text-transform: uppercase;
            padding: 20px;

            img {
                width: 50px;
                height: 50px;
            }

            button {
                width: 80px;
                height: 40px;
                text-transform: uppercase;
                border: none;
                border-radius: 20px;
                font-size: 11px;
                background-color: var(--primary);
                color: #fff;
                cursor: pointer;
            }
        }

    }

    @media (max-width: 768px) {
        width: 100%;

        table {
            border-radius: 0px;
            width: 100%;

        tr {
            width: 22%;
            text-align: center;
        }

        td {
            font-weight: 400;
            text-transform: uppercase;
            padding: 10px;
            font-size: 11px;

            img {
                width: 30px;
                height: 30px;
            }

            button {
                width: 65px;
                height: 40px;
                font-size: 11px;
            }
        }

        }

    }

`

const BackButton = styled.div`

    button {
        width: 60px;
        height: 30px;
        border: none;
        font-size: 11px;
        background-color: transparent;
        text-align: center;
        font-weight: 700;
        color: #333;
        margin-bottom: 20px;

        :hover {
            background-color: rgb(17, 140, 79, 0.3);
            border: none;
            transition: 0.3s ease-in;
        }
    }

`